import { useMemo } from "react";
import './print-labeled-ui.scss';
type Props = {
  label: string,
  children: React.ReactNode[] | React.ReactNode,
  hidden?: boolean;
  width?: number;
}

export const PrintLabeledUI = (props: Props) => {
  const {
    label,
    children,
    hidden,
    width,
  } = props;
  
  const style = useMemo(() => {
    if (width) {
      return {
        width: `${width}px`,
      }
    }
    return {};
  }, [width]);

  if (hidden) {
    return <></>;
  }

  return (
    <div className="print_labeled_ui">
      <div className="print_labeled_ui__label" style={{...style}}>{label}</div>
      <div className="print_labeled_ui__content">
        {children}
      </div>
    </div>
  )
}